import { Component } from "@angular/core";

@Component({
    selector: 'app-pvttax',
    templateUrl: './pvttax.component.html',
    styleUrls: ['./pvttax.component.css',
        '../taxbyservice.component.css'
    ]
})

export class PvtTax{
    searchTerm: string = '';
    taxedServices: any[] = [
      {
        serviceName: 'Amazon EC2',
        postTaxCharges: 105.50,
        preTaxCharges: 100.00,
        taxUSD: 5.50
      },
      {
        serviceName: 'Amazon S3',
        postTaxCharges: 210.00,
        preTaxCharges: 200.00,
        taxUSD: 10.00
      }
    ];
  
    headers = [
      { key: 'serviceName', label: 'Service Name' },
      { key: 'postTaxCharges', label: 'Post-Tax Charges' },
      { key: 'preTaxCharges', label: 'Pre-Tax Charges' },
      { key: 'taxUSD', label: 'Tax in USD' }
    ];
  
    get filteredServices() {
      const term = this.searchTerm.toLowerCase();
      return this.taxedServices.filter(service =>
        Object.values(service).some(val =>
          val?.toString().toLowerCase().includes(term)
        )
      );
    }
  
    sortBy(key: string) {
      this.taxedServices.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
    }
  
    getTotalTax(): number {
      return this.taxedServices.reduce((sum, item) => sum + (item.taxUSD || 0), 0);
    }
}